<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>
<style type="text/css">

:root {
  --primary-color: #2f3033;
  --secondary-color: #fcfcfc;
  --danger-color: #b71c1c;
  --teal-color: #00968;
}

.v-application--wrap {
  background-color: #eeeeee;
}

a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}

.w-100 {
  width: 100%;
}

/*  CARD STYLES*/

.tools-view-card {
  min-height: 80vh;
}

.card-title {
  color: var(--primary-color);;
}

/*GRID*/
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  grid-gap: 1rem;

}

/*EXPANSION PANEL*/
.expansion-panel-content {
  overflow: auto;
  max-height: 400px;
  word-wrap: break-word;
}

/*QR CODE STYLES*/
.qr-code_section img {
  width: 100%;
  max-height: 300px;
  max-width: 300px;
}

</style>
